import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addCart } from "../../redux/slices/Cart";
import toast from "react-hot-toast";
import { axiosInstance } from "../utils/axiosInstance";
import { FaCartPlus } from "react-icons/fa";
import { imgUrl } from "../utils/imgUrl";

const MenuCart = ({
  heart = false,
  wishlistCol = false,
  setUrl,
  productData,
  setShowModal,
  handleClose,
  showModal,
  width = false,
}) => {
  const cart = useSelector((state) => state?.cart?.cart);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const addWishlist = async (id) => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);
      const response = await axiosInstance.post("user/whishlist", formData);
      if (response?.data?.status === true) {
        toast.success(
          response?.data?.message ||
            "This Product Has Been Added In Your Favourite"
        );
      } else {
        toast.error(
          response?.data?.message || "Something went wrong, try again."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error?.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };
  const handleShow = (id) => {
    setUrl(`https://africanbbq-user.vercel.app/menudetail/${id}`);
    setShowModal(true);
  };

  return (
    <div
      className={
        width === true
          ? "wow fadeInUp"
          : wishlistCol
          ? "col-xl-4 col-md-6 col-sm-12 col-lg-4 wow fadeInUp"
          : "col-xl-3 col-md-6 col-sm-12 col-lg-4 wow fadeInUp"
      }
      data-wow-duration="1s"
    >
      <div className="menu_item" style={{ position: "relative" }}>
        {productData?.discount_status === 1 && (
          <div
            style={{
              position: "absolute",
              top: "20px",
              right: "10px",
              background: "#cd2128",
              padding: "0px 10px",
              // borderRadius: "50%",
              // width: "40px",
              // height: "40px",
              // clipPath:'circle()',
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              color: "#fff",
              zIndex: 99,
            }}
          >
            {productData?.discount_percent}% Off
          </div>
        )}
        <div
          className="menu_item_img"
          onClick={() =>
            navigate(`/menudetail/${productData?.id}`, {
              state: { productData },
            })
          }
        >
          <img
            src={imgUrl + productData?.images[0]?.name}
            alt="menu"
            className="img-fluid w-100"
          />
        </div>
        <div className="menu_item_text">
          <button
            className="category"
            onClick={() =>
              navigate(`/menudetail/${productData?.id}`, {
                state: { productData },
              })
            }
          >
            {productData?.category?.name}
          </button>
          <button
            onClick={() =>
              navigate(`/menudetail/${productData?.id}`, {
                state: { productData },
              })
            }
            className="title mx-auto bg-transparent"
          >
            {productData?.name}
          </button>
          <p className="rating">
            <i className="fas fa-star" />
            <i className="fas fa-star" />
            <i className="fas fa-star" />
            <i className="fas fa-star-half-alt" />
            <i className="far fa-star" />
            <span>24</span>
          </p>
          {productData?.discount_status === 1 ? (
            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <h5 className="price">$ {productData?.sizes[0]?.price}</h5>
              <h5
                className="price"
                style={{ textDecoration: "line-through", color: "red" }}
              >
                $ {productData?.sizes[0].sub_price}
              </h5>
            </div>
          ) : (
            <h5 className="price">$ {productData?.sizes[0]?.price}</h5>
          )}

          <button
            onClick={() => {
              toast.success(`${productData?.name} Cart Added Successfully`);
              const existingProductIndex = cart.findIndex(
                (item) =>
                  item.id === productData?.id &&
                  item.size === productData?.sizes[0].name
              );

              if (existingProductIndex !== -1) {
                const updatedCart = cart.map((item) =>
                  item.id === productData?.id &&
                  item.size === productData?.sizes[0].name
                    ? {
                        ...item,
                        quantity: item.quantity + 1,
                      }
                    : item
                );
                dispatch(addCart(updatedCart));
              } else {
                dispatch(
                  addCart([
                    ...cart,
                    {
                      ...productData,
                      quantity: 1,
                      size: productData?.sizes[0].name,
                      price: productData?.sizes[0].price,
                      product_ingredient_categories: [],
                    },
                  ])
                );
              }
            }}
            className="add_to_cart"
          >
            Add <FaCartPlus />
          </button>
          <ul
            className={`${
              width === true && "ps-5 ms-3"
            } d-flex flex-wrap justify-content-end`}
          >
            <li>
              <button
                style={{
                  background: heart ? "#cd2128" : "none",
                  color: heart ? "#fff" : "#cd2128",
                }}
                onClick={() => addWishlist(productData?.id)}
                className={`cardBtn`}
              >
                <i className="fal fa-heart" />
              </button>
            </li>
            <li>
              <button
                className="cardBtn"
                onClick={() =>
                  navigate(`/menudetail/${productData?.id}`, {
                    state: { productData },
                  })
                }
              >
                <i className="far fa-eye" />
              </button>
            </li>
            <li>
              <button
                className="cardBtn"
                onClick={() => handleShow(productData?.id)}
              >
                <i className="far fa-share" />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MenuCart;
